module.exports = __webpack_public_path__ + "static/step5-edb10d7a66d7f138344ad204f862abdb.png";